import { useState } from 'react';
import styled from 'foundations-theming/utils';
import { Image } from 'foundations-components/transitional/components/Image';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ThumbnailPlaceholder = styled.div.withConfig({
  displayName: "PlaylistThumbnailImage__ThumbnailPlaceholder"
})(["position:absolute;inset:0;background-color:", ";"], ({
  $isOwnedByUser,
  theme
}) => $isOwnedByUser ? theme.color['fill-primary-disabled'] : undefined);
const PlaylistThumbnailImage = ({
  src,
  alt,
  isOwnedByUser
}) => {
  const [loaded, setLoaded] = useState(false);
  if (!src) {
    return (
      /*#__PURE__*/
      // @bend-expect trellis-tokenized
      _jsx(ThumbnailPlaceholder, {
        $isOwnedByUser: isOwnedByUser,
        "data-test-id": "playlist-thumbnail-placeholder"
      })
    );
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [!loaded &&
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(ThumbnailPlaceholder, {
      $isOwnedByUser: isOwnedByUser,
      "data-test-id": "playlist-thumbnail-placeholder"
    }), /*#__PURE__*/_jsx(Image, {
      alt: alt,
      loading: "lazy",
      onLoad: () => setLoaded(true),
      src: src,
      visibility: loaded ? 'visible' : 'hidden'
    })]
  });
};
export default PlaylistThumbnailImage;